module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    style: (_vm.appStyle),
    attrs: {
      "id": "app"
    }
  }, [_c('AppHeader', {
    on: {
      "init": _vm.initHeader
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "app-body",
    style: ({
      marginTop: _vm.appBodyMarginTop
    }),
    attrs: {
      "id": "app-body"
    }
  }, [_c('Sidebar'), _vm._v(" "), _c('main', {
    staticClass: "main",
    staticStyle: {
      "z-index": "1"
    },
    style: ({
      marginLeft: _vm.mainMarginleft
    })
  }, [_c('breadcrumb', {
    attrs: {
      "list": _vm.list
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    style: ({
      overflow: _vm.overflow1
    })
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "20px",
      "background-color": "rgb(242, 244, 250)"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4318c12e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Full.vue
// module id = 1091
// module chunks = 284